import { useCallback, useEffect, useRef } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useSelectedAccount } from '@ibk/shared-auth';
import { getAccountName } from '@ibk/shared-utils';
export function useBillingTracking() {
    const { selectedAccount } = useSelectedAccount();
    const companyName = getAccountName(selectedAccount);
    const companyNameRef = useRef(companyName);
    const pendingRef = useRef([]);
    useEffect(() => {
        companyNameRef.current = companyName;
        if (companyName && pendingRef.current.length > 0) {
            pendingRef.current.forEach(p => {
                datadogRum.addAction(p.action_name, { company_name: companyName });
            });
            pendingRef.current = [];
        }
    }, [companyName]);
    const trackBillingEvent = useCallback((params) => {
        if (companyNameRef.current) {
            datadogRum.addAction(params.action_name, { company_name: companyNameRef.current });
        }
        else {
            pendingRef.current.push(params);
        }
    }, []);
    const trackBillingView = useCallback((params) => {
        datadogRum.startView({ name: params.view_name });
    }, []);
    return { trackBillingEvent, trackBillingView };
}
